import React from "react";
import TopSection from "./TopSection";

const Criteria = () => {
  return (
    <>
<TopSection
  subtitle="Критерии оценки для номинаций"
  title="Global Construction Cup"
/>
    <div className="regulation-wrapper">


      <section className="regulation-section">
        <div className="regulation-content">
          <h2 className="regulation-title">1. Лидер года в строительной отрасли</h2>
          
          <ul className="who-list">
            <li>Влияние на развитие компании: рост прибыли, объема выполненных проектов и укрепление рыночных позиций компании — до 10 баллов.</li>
            <li>Управленческие достижения: успешная реализация ключевых проектов в течение года — до 10 баллов.</li>
            <li>Репутация: положительные отзывы от коллег, партнеров и клиентов — до 10 баллов.</li>
            <li>Стратегическое видение: разработка и внедрение долгосрочных стратегий развития компании — до 10 баллов.</li>
            <li>Вклад в отрасль: участие в отраслевых инициативах, форумах и проектах — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>

          <h2 className="regulation-title">2. За внедрение инноваций в строительстве</h2>
          <ul className="who-list">
            <li>Новизна решений: применение уникальных технологий или методов в строительных проектах — до 10 баллов.</li>
            <li>Результативность: улучшение качества, сроков или экономических показателей благодаря инновациям — до 10 баллов.</li>
            <li>Масштаб внедрения: объем проектов, где использованы инновационные технологии — до 10 баллов.</li>
            <li>Влияние на отрасль: возможность использования разработанных решений другими участниками рынка — до 10 баллов.</li>
            <li>Экологическая эффективность: внедрение технологий, минимизирующих негативное воздействие на окружающую среду — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>

          <h2 className="regulation-title">3. Лучший руководитель строительной компании</h2>
          <ul className="who-list">
            <li>Эффективность управления: достижение высоких результатов в производительности, качестве и соблюдении сроков — до 10 баллов.</li>
            <li>Финансовая стабильность: рост ключевых показателей компании за последние годы — до 10 баллов.</li>
            <li>Репутация компании: признание компании на рынке, награды и положительные отзывы — до 10 баллов.</li>
            <li>Лидерство и коммуникации: умение вдохновлять сотрудников и выстраивать эффективные команды — до 10 баллов.</li>
            <li>Клиенториентированность: высокий уровень удовлетворенности заказчиков — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>

          <h2 className="regulation-title">4. Эффективное управление проектами</h2>
          <ul className="who-list">
            <li>Соблюдение сроков: успешное завершение проектов в установленные временные рамки — до 10 баллов.</li>
            <li>Финансовая эффективность: управление бюджетом без перерасхода средств — до 10 баллов.</li>
            <li>Качество выполненных работ: соответствие проектов установленным стандартам и требованиям — до 10 баллов.</li>
            <li>Риск-менеджмент: способность предвидеть и минимизировать риски — до 10 баллов.</li>
            <li>Координация команд: эффективное взаимодействие между всеми участниками проекта — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>

          <h2 className="regulation-title">5. За вклад в устойчивое строительство</h2>
          <ul className="who-list">
            <li>Экологические подходы: использование энергоэффективных и экологичных материалов — до 10 баллов.</li>
            <li>Снижение углеродного следа: применение технологий, уменьшающих выбросы CO2 — до 10 баллов.</li>
            <li>Управление отходами: организация переработки и утилизации строительных отходов — до 10 баллов.</li>
            <li>Социальное воздействие: учет интересов местных сообществ при реализации проектов — до 10 баллов.</li>
            <li>Энергоэффективность: внедрение решений, снижающих потребление энергии в зданиях — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>

          <h2 className="regulation-title">6. Лидер цифровой трансформации в строительстве</h2>
          <ul className="who-list">
            <li>Внедрение технологий: применение BIM, автоматизации процессов, использования искусственного интеллекта и других цифровых решений — до 10 баллов.</li>
            <li>Результативность: увеличение скорости, качества и прозрачности работы благодаря цифровизации — до 10 баллов.</li>
            <li>Масштабность: объем процессов и подразделений компании, охваченных цифровыми решениями — до 10 баллов.</li>
            <li>Обучение сотрудников: организация программ повышения квалификации для работы с новыми технологиями — до 10 баллов.</li>
            <li>Влияние на конкурентоспособность: улучшение позиций компании на рынке благодаря цифровой трансформации — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>

          <h2 className="regulation-title">7. За вклад в развитие отрасли</h2>
          <ul className="who-list">
            <li>Общественная деятельность: участие в профессиональных объединениях, отраслевых инициативах и форумах — до 10 баллов.</li>
            <li>Образовательные проекты: создание и продвижение программ для подготовки кадров — до 10 баллов.</li>
            <li>Инновации: разработки, влияющие на развитие строительной отрасли — до 10 баллов.</li>
            <li>Долгосрочный эффект: результаты, которые будут актуальны для отрасли в будущем — до 10 баллов.</li>
            <li>Популяризация отрасли: участие в мероприятиях, направленных на повышение статуса строительной профессии — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>

          <h2 className="regulation-title">8. Командный лидер года</h2>
          <ul className="who-list">
            <li>Эффективное руководство: создание сплоченной команды, достигающей высоких результатов — до 10 баллов.</li>
            <li>Мотивация сотрудников: поддержка сотрудников, создание условий для их роста и развития — до 10 баллов.</li>
            <li>Распределение задач: умение правильно расставлять приоритеты и эффективно делегировать — до 10 баллов.</li>
            <li>Результаты команды: успешная реализация проектов благодаря командной работе — до 10 баллов.</li>
            <li>Влияние на корпоративную культуру: улучшение атмосферы внутри коллектива — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>
          <h2 className="regulation-title">9. За стратегическое управление развитием компании</h2>
          <ul className="who-list">
            <li>Стратегическое планирование: разработка долгосрочных целей и планов развития — до 10 баллов.</li>
            <li>Реализация стратегии: успешное выполнение намеченных планов и достижение результатов — до 10 баллов.</li>
            <li>Рост компании: увеличение доходов, расширение географии и портфеля проектов — до 10 баллов.</li>
            <li>Адаптивность: способность компании реагировать на изменения рынка и конкуренции — до 10 баллов.</li>
            <li>Инвестиционная привлекательность: увеличение доверия со стороны инвесторов и партнеров — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>
          <h2 className="regulation-title">10. За развитие корпоративной культуры и команды</h2>
          <ul className="who-list">
            <li>Создание комфортной рабочей среды: внедрение практик, повышающих удовлетворенность сотрудников — до 10 баллов.</li>
            <li>Корпоративные ценности: развитие и укрепление общих принципов и миссии компании — до 10 баллов.</li>
            <li>Обучение и развитие сотрудников: организация тренингов, программ повышения квалификации и наставничества — до 10 баллов.</li>
            <li>Уровень вовлеченности: повышение мотивации сотрудников и их участие в достижении целей компании — до 10 баллов.</li>
            <li>Социальная ответственность: реализация инициатив, направленных на поддержку сотрудников и общества — до 10 баллов.</li>
          </ul>
          <p className="regulation-subtext">Максимальная оценка за номинацию: 50 баллов.</p>
        </div>
      </section>
    </div>
    </>
  );
};

export default Criteria;
